import { component } from "picoapp";

export const enterKeypressEvent = component((node) => {
  function toggleCheckbox(e: KeyboardEvent) {
    if (e.code === "Enter") {
      const checkboxInput = node.querySelector<HTMLInputElement>(
        'input[name="address[default]"]'
      );
      checkboxInput.checked
        ? (checkboxInput.checked = false)
        : (checkboxInput.checked = true);
      e.preventDefault();
    }
  }

  node.addEventListener("keypress", toggleCheckbox);

  return () => {
    node.removeEventListener("keypress", toggleCheckbox);
  };
});
